import { RecoveryExecution } from "@/features/recovery/recovery-execution";

export default function RecoveryExecutionPage() {
  return <RecoveryExecution />;
}
